import { __awaiter, __generator } from "tslib";
import { areThirdPartyAppsEqual } from '../utilities/areThirdPartyAppsEqual';
import { getUsedThirdPartyAppsUserData, setUsedThirdPartyAppsUserData, } from '../utilities/usedThirdPartyAppsUtils';
export function invalidateUsedThirdPartyAppCache(thirdPartyWorkloads, componentContext) {
    return __awaiter(this, void 0, void 0, function () {
        var correlationId, getAccessToken, getIdentity, inMockMode, jwtAuthEnabled, officeHomeApiRoot, workload, userStorageOptions, usedThirdPartyWorkloads, updatedUsedThirdPartyWorkloads_1, listUpdated_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    correlationId = componentContext.correlationId, getAccessToken = componentContext.getAccessToken, getIdentity = componentContext.getIdentity, inMockMode = componentContext.inMockMode, jwtAuthEnabled = componentContext.jwtAuthEnabled, officeHomeApiRoot = componentContext.officeHomeApiRoot, workload = componentContext.workload;
                    userStorageOptions = {
                        correlationId: correlationId,
                        getAccessToken: getAccessToken,
                        getIdentity: getIdentity,
                        inMockMode: inMockMode,
                        jwtAuthEnabled: jwtAuthEnabled,
                        officeHomeApiRoot: officeHomeApiRoot,
                        workload: workload,
                    };
                    return [4 /*yield*/, getUsedThirdPartyAppsUserData(userStorageOptions)];
                case 1:
                    usedThirdPartyWorkloads = _a.sent();
                    if (usedThirdPartyWorkloads && usedThirdPartyWorkloads.length > 0) {
                        updatedUsedThirdPartyWorkloads_1 = [];
                        listUpdated_1 = false;
                        usedThirdPartyWorkloads.forEach(function (usedThirdPartyWorkload) {
                            var workload = thirdPartyWorkloads.find(function (thirdPartyWorkload) {
                                return thirdPartyWorkload.Id === usedThirdPartyWorkload.Id;
                            });
                            if (!workload) {
                                listUpdated_1 = true;
                            }
                            else if (!areThirdPartyAppsEqual(workload, usedThirdPartyWorkload)) {
                                updatedUsedThirdPartyWorkloads_1.push(workload);
                                listUpdated_1 = true;
                            }
                            else {
                                updatedUsedThirdPartyWorkloads_1.push(workload);
                            }
                        });
                        if (listUpdated_1) {
                            return [2 /*return*/, setUsedThirdPartyAppsUserData(updatedUsedThirdPartyWorkloads_1, userStorageOptions)];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=invalidateUsedThirdPartyAppCache.js.map